var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    { attrs: { visible: _vm.visible }, on: { "on-close": _vm.close } },
    [
      _c(
        "div",
        { class: ["modal-confirm", { "modal-confirm-rich": !!_vm.showIcon }] },
        [
          _vm.showIcon
            ? _c(
                "div",
                { staticClass: "modal-confirm-icon" },
                [_c("f-sprite-icon", { attrs: { "icon-link": _vm.icon } })],
                1
              )
            : _vm._e(),
          _vm.title
            ? _c("div", {
                staticClass: "modal-confirm-title",
                domProps: { innerHTML: _vm._s(_vm.title) }
              })
            : _vm._e(),
          _vm.subtitle
            ? _c("div", {
                staticClass: "modal-confirm-subtitle",
                domProps: { innerHTML: _vm._s(_vm.subtitle) }
              })
            : _vm._e(),
          _vm.buttons.length
            ? _c(
                "div",
                { staticClass: "modal-confirm-buttons" },
                _vm._l(_vm.buttons, function(b, i) {
                  return _c("ui-button", {
                    key: i,
                    attrs: {
                      text: b.text,
                      flat: !!b.flat,
                      secondary: !!b.secondary
                    },
                    on: {
                      click: function($event) {
                        return _vm.buttonClick(b.action)
                      }
                    }
                  })
                }),
                1
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }